import React from "react";
import { useIsMobile } from "../../hooks/useIsMobile";
import { lifeAtSeekhoVideo } from "../../utils/constants/Team";
import JoinOurTeam from "../common/JoinOurTeamCTA";
import Fade from "react-reveal/Fade";

const LifeAtSeekhoVideo = () => {
  const { isMobile } = useIsMobile();
  return (
    <section>
      <Fade bottom>
        <h6 className="text-center text-[24px] font-lexend font-semibold lg:text-[40px]">
          A Peek Into Life At Seekho
        </h6>
      </Fade>
      <div className="border border-[#3a3a3a] bg-[#141414] rounded-2xl w-full mx-auto mt-6 pb-2 md:w-[55%] md:pb-6 lg:pb-8 lg:w-[50%]">
        {/* YouTube video embed */}
        <div className="mx-auto w-full rounded-2xl overflow-hidden">
          <iframe
            className="w-full aspect-video rounded-2xl"
            src={lifeAtSeekhoVideo}
            title="Life at Seekho"
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen
          />
        </div>

        <h6 className="text-[16px] leading-[20px] font-lexend font-semibold text-center mt-8 lg:text-[24px] lg:leading-[32px]">
          Ready to be part of our story?
        </h6>
        <p className="text-[12px] leading-[16px] font-lexend text-center text-[#8f8f8f] mt-4 lg:text-[18px] lg:leading-[24px] lg:mt-5">
          Join our passionate team and help us build <br /> the future of
          Edutainment.
        </p>
        <JoinOurTeam
          mobileStatus={isMobile ? "video_cta" : undefined}
          desktopStatus={!isMobile ? "video_cta" : undefined}
          ctaClassName="mx-auto text-[16px] min-w-[95%] mt-6 md:px-6 md:min-w-fit md:!text-[20px] lg:px-12"
          arrowClass="text-[16px] md:!text-[24px]"
        />
      </div>
    </section>
  );
};

export default LifeAtSeekhoVideo;
